import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreateComponent } from './main/create/create.component';
import { MsalGuard } from './msal';
import { UnauthorizedComponent } from './main/unauthorized/unauthorized.component';

const routes: Routes = [
  { path: '', component: CreateComponent, data: { breadcrumb: '' }, canActivate: [MsalGuard] },
  { path: 'unauthorized', component: UnauthorizedComponent, data: { breadcrumb: '' } }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
